import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const http = axios.create({ baseURL: API, withCredentials: true });

export const formatApiError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return detail?.msg || String(detail);
};

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    http.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(async () => {
        try {
          const r = await http.post("/auth/refresh");
          setUser(r.data);
        } catch {
          setUser(false);
        }
      });
  }, []);

  const login = async (email, password) => {
    const r = await http.post("/auth/login", { email, password });
    setUser(r.data);
    return r.data;
  };

  const logout = async () => {
    await http.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, logout, http }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
